import { getLatestAssignment } from "@/assignments/utils/getLatestAssignment/getLatestAssignment";
import { Assignment } from "@/types/models/Assignment.interface";
import getAssignmentSetting from "@/view/utils/getAssignmentSetting";

export const isReadActionVisible = (
  isViewingAsStudent: boolean,
  contentIsVideo: boolean,
  selectedAssignment: Assignment,
) => {
  const readActionHiddenForStudents =
    isViewingAsStudent &&
    getAssignmentSetting("hide_read_aloud", selectedAssignment);
  return !contentIsVideo && !readActionHiddenForStudents;
};

export const getSelectedAssignment = (
  matchedAssignments = [] as Assignment[],
  selectedAssignmentId?: string,
) => {
  return (
    matchedAssignments.find(
      (assignment) => assignment?.content_id === selectedAssignmentId,
    ) ||
    getLatestAssignment(matchedAssignments) ||
    undefined
  );
};
